'use client';
const STORAGE = typeof window !== 'undefined' ? localStorage : null;

class StorageService {
    static get(key) {
        if (!STORAGE) return null;
        let value = STORAGE.getItem(key);

        return value === null || value === 'undefined' ? null : JSON.parse(value);
    }

    static set(key, value) {
        return STORAGE.setItem(key, JSON.stringify(value));
    }

    static unset(key) {
        if (this.isset(key)) return STORAGE.removeItem(key);
        else return null;
    }

    static clear() {
        this.unset('user');
        this.unset('role');
        this.unset('permissions');
        this.unset('settings');
        this.unset('redirection');
        // this.unset('domain');
        // this.unset('domain-type');
        return null;
    }

    static isset(key) {
        return this.get(key) !== null;
    }
}

export default StorageService;
